import { useEffect } from "react";
import { styled } from "styled-components";

import { ErrorMessage } from "common/components";
import { CopyLinkField } from "common/components/CopyLinkField";
import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { createLink } from "domains/createShareSettings/actions";
import { getShareLinkError, getShareLinkIsPending, getShareLinkToken } from "domains/createShareSettings/selectors";
import { ModalHeader } from "domains/modal/components/ModalHeader";
import { getModalParams } from "domains/modal/selectors";
import type { ModalParams } from "domains/modal/types";

const StyledText = styled.div`
  margin: 0;
  margin-bottom: 1rem;
`;

export const MapShareLinkModal = () => {
  const dispatch = useDispatch();
  const { permission, topicId } = useSelector(getModalParams) as ModalParams<"MapShareLink">;
  const isPending = useSelector(getShareLinkIsPending);
  const token = useSelector(getShareLinkToken);
  const error = useSelector(getShareLinkError);

  const translate = useTranslate();

  useEffect(() => {
    if (topicId && (permission === "viewer" || permission === "editor")) {
      dispatch(createLink({ topic_id: topicId, permission }));
    }
  }, [dispatch, topicId, permission]);

  const link = `${import.meta.env.VITE_WEBSITE_URL}/map-invite-link/${token}`;
  return (
    <>
      <ModalHeader title={translate("app.map_share.invite_with_link")} />
      <StyledText>{translate("app.map_share.invite_with_link.message")}</StyledText>
      {error ? (
        <ErrorMessage isActive={error}>{translate("app.map_share.invite_with_link.failure")}</ErrorMessage>
      ) : (
        <CopyLinkField url={!token || isPending ? translate("app.loading") : link} />
      )}
    </>
  );
};
